import React from 'react';
import { FlexRow } from '../layouts';
import { Image, Breadcrumb } from 'semantic-ui-react';
import UserProfile from './UserProfile';
import {useNavigate} from "react-router-dom";

export interface ICrumb {
  key: string;
  route: string;
  content: string;
  active: boolean;
  onClick?: () => any;
}

export interface IPage {
  crumbs: ICrumb[];
  children: any;
}

const Page = (props: IPage) => {
  const { children, crumbs } = props;

  const navigate = useNavigate();

  console.log(process.env);
  return (
    <>
      <FlexRow padLeft={32} padTop={32} padBottom={32} fullWidth>
        <FlexRow twoThirdsWidth alignLeftCenter>
          <Image src={`/${process.env.REACT_APP_LOGO_IMAGE}`} onClick={() => navigate('/')} style={{cursor: 'pointer'}}/>
          <FlexRow padTop={25} padLeft={30}>
            <Breadcrumb sections={crumbs} size="huge" />
          </FlexRow>
        </FlexRow>
        <FlexRow thirdWidth right>
          <UserProfile />
        </FlexRow>
      </FlexRow>
      <div style={{width: '100%', paddingLeft: 32, paddingRight: 32}}>
        {children}
      </div>
    </>
  );
};

export default Page;
